'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Phone, Mail, MapPin, X } from 'lucide-react';

interface ContactModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ContactModal({ open, onOpenChange }: ContactModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">联系我们</DialogTitle>
          <DialogDescription>
            中科企服科技为您提供专业科技服务
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          {/* 联系电话 */}
          <div className="flex items-start space-x-3 p-4 bg-blue-50 rounded-lg">
            <Phone className="h-5 w-5 text-blue-600 mt-0.5" />
            <div className="flex-1">
              <p className="font-medium text-gray-900">联系电话</p>
              <a
                href="tel:4000757209"
                className="text-lg font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                187-0278-9722
              </a>
              <p className="text-sm text-gray-600 mt-1">李老师</p>
            </div>
          </div>

          {/* 邮箱 */}
          <div className="flex items-start space-x-3 p-4 rounded-lg border">
            <Mail className="h-5 w-5 text-gray-600 mt-0.5" />
            <div className="flex-1">
              <p className="font-medium text-gray-900">电子邮箱</p>
              <a
                href="mailto:781260356@qq.com"
                className="text-sm text-gray-600 hover:text-blue-600 transition-colors"
              >
                781260356@qq.com
              </a>
            </div>
          </div>

          {/* 地址 */}
          <div className="flex items-start space-x-3 p-4 rounded-lg border">
            <MapPin className="h-5 w-5 text-gray-600 mt-0.5" />
            <div className="flex-1">
              <p className="font-medium text-gray-900">公司地址</p>
              <p className="text-sm text-gray-600">武汉经济技术开发区车城东路10号创思汇科技大厦16层1601-43号室</p>
            </div>
          </div>

          {/* 立即拨打按钮 */}
          <a href="tel:4000757209" className="block">
            <Button className="w-full bg-blue-600 hover:bg-blue-700" size="lg">
              <Phone className="h-4 w-4 mr-2" />
              立即拨打：187-0278-9722
            </Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}